import React, { useMemo } from 'react';
import useStore from 'store/AccountStore';
import OpSelect from 'op2mise-react-widgets/OpSelect/OpSelect';
import styles from './OrganisationSelect.module.css';

const ORGANISATION_FIELDS = { text: 'name', value: 'id' };
const NO_ORGANISATION_PLACEHOLDER = 'No organisation';

function OrganisationSelect() {
  const { user } = useStore((state) => state);

  const organisations = useMemo(
    () =>
      (user?.organisations ?? []).map((org) => ({
        id: org.organisationId,
        name: org.name,
      })),
    [user?.organisations]
  );

  return (
    <div className={styles.organisationSelect}>
      <label>Organisation:</label>
      <OpSelect
        dataSource={organisations}
        enabled={false}
        fields={ORGANISATION_FIELDS}
        placeholder={NO_ORGANISATION_PLACEHOLDER}
        value={user?.organisationId ?? null}
        width={200}
      />
    </div>
  );
}

export default OrganisationSelect;
